import { useFormikContext } from 'formik'
import { FormControl, Switch, Typography } from '@mui/material'

import { useAccount } from 'src/hooks'
import { EAccountSubscriptionPlans, ETranslationNs, IMediaFileWithId } from 'src/types'

import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  showSwitch?: boolean
}

export const MainImageSwitch = ({ showSwitch }: IProps) => {
  const { values, handleChange } = useFormikContext<IMediaFileWithId>()
  const { data: account, isLoading } = useAccount()

  const freeAccount =
    account?.subscription_plan === EAccountSubscriptionPlans.free || isLoading || !account
  const isSuitableFormat = values.type.startsWith('image/') || values.type.startsWith('video/')
  const isShowEnabled = values.show_item

  const disabled = showSwitch
    ? !isShowEnabled || freeAccount || !isSuitableFormat
    : freeAccount || !isSuitableFormat

  const checked = showSwitch ? values.main_image && values.show_item : values.main_image

  return (
    <>
      <FormControl style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Switch
          checked={isSuitableFormat ? checked : false}
          onChange={handleChange}
          name="main_image"
          style={{ marginRight: 0 }}
          disabled={disabled}
        />
        <Typography variant={'caption'}>
          <HelperWrapper
            t="main-image-label"
            ns={ETranslationNs.Form}
            disabled={disabled}
            popapWidth="145px"
          />
        </Typography>
      </FormControl>
    </>
  )
}
